import dt from 'date-and-time';

class Skill {
    constructor(data) {
        this.data = data;
        this.init();

        this.__resume = null;
    }

    init() {
    }

    getResume() {
        return this.__resume;
    }

    setResume(value) {
        this.__resume = value;
    }

    isOfType(type) {
        return this.data.type_id === type.data.id;
    }

    rating() {
        return this.data.value / this.data.range;
    }
}

class SkillType {
    constructor(data) {
        this.data = data;
        this.init();

        this.__resume = null;
    }

    init() {
    }

    getResume() {
        return this.__resume;
    }

    setResume(value) {
        this.__resume = value;
    }

    findSkillList() {
        return this.getResume().findSkillsListByType(this);
    }
}

class Role {
    constructor(data) {
        this.data = data;
        this.init();

        this.__experience = null;
    }

    init() {
    }

    getExperience() {
        return this.__experience;
    }

    setExperience(value) {
        this.__experience = value;
    }

    dateRange() {
        const dates = this.data.dates;

        let range = '';
        if (dates.start) {
            range = this.formatDate(dates.start) + ' - ';
            if (dates.end) {
                range += this.formatDate(dates.end);
            } else {
                range += 'present';
            }
        } else {
            range = 'present';
        }

        return range;
    }

    formatDate(config) {
        const date = new Date();
        date.setFullYear(config.year);
        date.setMonth(config.month - 1);
        date.setDate(15);
        date.setHours(1);
        date.setMinutes(1);
        date.setSeconds(1);

        return dt.format(date, "MMM YYYY", false);
    }
}

class Project {
    constructor(data) {
        this.data = data;
        this.init();

        this.__resume = null;
    }

    init() {
    }

    get name() {
        return this.data.name;
    }

    get description() {
        return this.data.description || [];
    }

    get url() {
        return this.data.url;
    }

    get logoFile() {
        return this.data.logo_file;
    }

    get launchDate() {
        const dates  = this.data.dates;
        const launch = dates.launch;

        const date = new Date();
        date.setFullYear(launch.year);
        date.setMonth(launch.month - 1);
        date.setDate(1);
        date.setHours(12);
        date.setMinutes(0);
        date.setSeconds(0);

        return dt.format(date, "MMM YYYY", false);
    }

    getResume() {
        return this.__resume;
    }

    setResume(value) {
        this.__resume = value;
    }
}

class WorkExperience {
    constructor(data) {
        this.data = data;
        this.init();

        this.__resume = null;
    }

    init() {
        this.roles = (this.data.roles || []).map((data) =>  {
            const role = new Role(data);
            role.setExperience(this);
            return role;
        });
    }

    getResume() {
        return this.__resume;
    }

    setResume(value) {
        this.__resume = value;
    }

    notes() {
        return this.data.notes || [];
    }

    highlights() {
        return this.data.highlights || [];
    }

    details() {
        return this.data.details || [];
    }
}

class Education {
    constructor(data) {
        this.data = data;
        this.init();

        this.__resume = null;
    }

    init() {
    }

    getResume() {
        return this.__resume;
    }

    setResume(value) {
        this.__resume = value;
    }

    getDateString() {
        const conferral = this.data.conferral;

        const date = new Date();
        date.setFullYear(conferral.year);
        date.setMonth(conferral.month - 1);
        date.setDate(15);
        date.setHours(1);
        date.setMinutes(1);
        date.setSeconds(1);

        return dt.format(date, "MMM YYYY", false);
    }
}

class Resume {
    constructor(data) {
        this.data = data;
        this.init();
    }

    init() {
        this.education = (this.data.education || []).map((data) =>  {
            const edu = new Education(data);
            edu.setResume(this);
            return edu;
        });

        this.projects = (this.data.projects || []).map((data) =>  {
            const project = new Project(data);
            project.setResume(this);
            return project;
        });

        this.experience = (this.data.experience || []).map((data) =>  {
            const exp = new WorkExperience(data);
            exp.setResume(this);
            return exp;
        });

        this.skillTypes = (this.data.skill_types || []).map((data) =>  {
            const type = new SkillType(data);
            type.setResume(this);
            return type;
        });

        this.skills = (this.data.skills || []).map((data) =>  {
            const skill = new Skill(data);
            skill.setResume(this);
            return skill;
        });
    }

    orderedSkillTypes() {
        return this.skillTypes.sort((a, b) => {
            return a.data.order - b.data.order;
        });
    }

    findSkillsListByType(type) {
        return this.skills.filter((skill) => skill.isOfType(type));
    }

    fullName() {
        const parts = [];

        const profile = this.data.profile || {};
        const name    = profile.name || {};

        if (name.first) {
            parts.push(name.first);
        }

        if (name.middle) {
            parts.push(name.middle);
        }

        if (name.last) {
            parts.push(name.last);
        }

        return parts.join(' ');
    }

    fullAddress() {
        const parts = [];

        const profile = this.data.profile || {};
        const contact = profile.contact || {};
        const address = contact.address || {};

        if (address.street_address) {
            parts.push(address.street_address);
        }

        if (address.city) {
            parts.push(address.city);
        }

        const parts2 = [];

        if (address.state) {
            parts2.push(address.state);
        }

        if (address.zip_code) {
            parts2.push(address.zip_code);
        }

        if (parts2.length) {
            parts.push(parts2.join(' '));
        }

        return parts.join(', ');
    }

    primaryEmail() {
        const profile = this.data.profile || {};
        const contact = profile.contact || {};
        const emails  = contact.email || [];

        const email = emails.find((item) => item.primary);

        if (email) {
            return email.value;
        }

        return '';
    }

    primaryPhone() {
        const profile = this.data.profile || {};
        const contact = profile.contact || {};
        const phones  = contact.phone || [];

        const phone = phones.find((item) => item.primary);

        if (phone) {
            return phone.value;
        }

        return '';
    }

    urls() {
        const profile = this.data.profile || {};
        return profile.url || [];
    }

    normalUrls() {
        return this.urls().map(url => {
            return {
                ...url,
                baseUrl : url.value.replace(/^https?:\/\//, '')
            };
        });
    }

    baseUrls() {
        return this.urls().map(url => url.value.replace(/^https?:\/\//, ''));
    }

    primaryUrl() {
        const url = this.urls().find((item) => item.primary);

        if (url) {
            return url.value;
        }

        return '';
    }

    objective() {
        return this.data.objective || '';
    }

    workExperience() {
        return this.data.experience || [];
    }
}

export default Resume;
